export function scheduleIdleTask(callback: () => void): () => void {
  if (typeof window === 'undefined') return () => undefined;
  if (window.requestIdleCallback && window.cancelIdleCallback) {
    const handle = window.requestIdleCallback(callback, { timeout: 1800 });
    return () => window.cancelIdleCallback(handle);
  }
  const handle = window.setTimeout(callback, 1);
  return () => window.clearTimeout(handle);
}
